var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.66658H9.33333V10.6666H22.6667V6.66658H25.3333V13.3333H28V6.66658C28 5.19992 26.8 3.99992 25.3333 3.99992H19.76C19.2 2.45325 17.7333 1.33325 16 1.33325C14.2667 1.33325 12.8 2.45325 12.24 3.99992H6.66667C5.2 3.99992 4 5.19992 4 6.66658V25.3333C4 26.7999 5.2 27.9999 6.66667 27.9999H14.6667V25.3333H6.66667V6.66658ZM16 3.99992C16.7333 3.99992 17.3333 4.59992 17.3333 5.33325C17.3333 6.06659 16.7333 6.66658 16 6.66658C15.2667 6.66658 14.6667 6.06659 14.6667 5.33325C14.6667 4.59992 15.2667 3.99992 16 3.99992Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 15.3333L20.6803 22.6666L16.667 18.6666L14.667 20.6666L20.6803 26.6666L30.0003 17.3333L28.0003 15.3333Z",
    fill: "#4B5563"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.08919c563d088c78ba369fcf5f12c0e7.svg";
export { ForwardRef as ReactComponent };